import { IUserDetails } from "../components/with-auth-context";
import { assertNever } from "../utils/never";
import { AbstractDocument } from './autogen/AbstractDocument';
import { UserLevel } from "./autogen/UserLevel";
import { SearchableContentType } from "./autogen/SearchableContentType";

export function getContentTypes(level: UserLevel): SearchableContentType[] {
    const types = [];
    if (level != UserLevel.Disabled) {
        if (level > UserLevel.External) {
            types.push(SearchableContentType.IssueBrief);
            types.push(SearchableContentType.Achievement);
            types.push(SearchableContentType.Resource);
            types.push(SearchableContentType.ProfileOfMP);
            types.push(SearchableContentType.FAQ);
            types.push(SearchableContentType.Person);
            types.push(SearchableContentType.OpinionEditorial);
            types.push(SearchableContentType.Quote);
            //types.push(SearchableContentType.Tweet);
        }
        types.push(SearchableContentType.MediaLines);
        types.push(SearchableContentType.DebateNotes);
    }
    return types;
}

export function getDataEntryContentTypes(level: UserLevel): SearchableContentType[] {
    const types = [];
    if (level != UserLevel.Disabled) {
        if (level > UserLevel.External) {
            types.push(SearchableContentType.IssueBrief);
            types.push(SearchableContentType.Achievement);
            types.push(SearchableContentType.Resource);
            types.push(SearchableContentType.ProfileOfMP);
            types.push(SearchableContentType.FAQ);
            types.push(SearchableContentType.Person);
            types.push(SearchableContentType.OpinionEditorial);
            types.push(SearchableContentType.Quote);
        }
        types.push(SearchableContentType.MediaLines);
        types.push(SearchableContentType.DebateNotes);
    }
    return types;
}

export function canViewNonePrioritisedMediaLinesInMediaLinesPage(user: IUserDetails): boolean {
    return user.level >= UserLevel.External;
}

export function isMyDocument(doc: AbstractDocument, user: IUserDetails): boolean {
    return doc.createdByUser == user.id;
}

export function canEditTopLines(user: IUserDetails): boolean {
    return user.level >= UserLevel.Editor;
}

export function canEditDocument(doc: AbstractDocument, user: IUserDetails): boolean {
    if (doc.isDeleted == true) {
        return false;
    }
    switch (user.level) {
        case UserLevel.Disabled:
            return false;
        case UserLevel.External:
            return getContentTypes(user.level).indexOf(doc.type as any) >= 0 && isMyDocument(doc, user);
        case UserLevel.SystemUser:
            return isMyDocument(doc, user);
        case UserLevel.Editor:
        case UserLevel.Admin:
            return true;
        default:
            assertNever(user.level);
    }
    return false;
}

export function canDeleteDocument(doc: AbstractDocument, user: IUserDetails) {
    return (!!doc.isDeleted == false) && user.level >= UserLevel.Editor;
}

export function canPublishDocument(doc: AbstractDocument, user: IUserDetails) {
    return (!!doc.isDeleted == false) && user.level >= UserLevel.Editor;
}


// WEBPACK FOOTER //
// ./src/model/content-access.ts